import React from 'react';
import CountUp from 'react-countup';
import { RevealSection, StaggerGrid } from './shared';

export const StatsSection = ({ sid, theme, stats, txt }) => (
  <section id={sid} className="py-16 sm:py-24 section-divider" style={{ background: 'linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)' }} data-testid="stats-section">
    <RevealSection>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <StaggerGrid className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
          {[
            { value: stats.installations, suffix: '+', label: txt('stats', 'installations'), testId: 'stat-installations' },
            { value: stats.customers, suffix: '', label: txt('stats', 'customers'), testId: 'stat-customers' },
            { value: stats.engineers, suffix: '', label: txt('stats', 'engineers'), testId: 'stat-engineers' },
            { value: stats.partners, suffix: '', label: txt('stats', 'partners'), testId: 'stat-partners' },
          ].map((stat) => (
            <div key={stat.testId} className="text-center group cursor-default p-6 sm:p-8 rounded-2xl bg-white border border-slate-100 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500">
              <div className="stat-number text-3xl sm:text-5xl md:text-6xl font-bold mb-1 sm:mb-2" style={{ fontFamily: `${theme.font_heading}, sans-serif`, color: theme.primary_color }} data-testid={stat.testId}>
                <CountUp end={stat.value} duration={3} suffix={stat.suffix} enableScrollSpy={true} scrollSpyOnce={true} />
              </div>
              <div className="text-slate-500 text-xs sm:text-base md:text-lg font-medium group-hover:text-slate-700 transition-colors duration-300" style={{ fontFamily: `${theme.font_body}, sans-serif` }}>
                {stat.label}
              </div>
            </div>
          ))}
        </StaggerGrid>
      </div>
    </RevealSection>
  </section>
);
